export function authHeader() {
    // return authorization header with basic auth credentials
    // let user = JSON.parse(sessionStorage.getItem('user'));// 15/06/23(User Req to remove MultiTab Login)
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.authdata) {
        return { 'Authorization': 'Basic ' + user.authdata };
    } else {
        return {};
    }
}